/* eslint-disable no-undef */
const _fbq = (...args) => {
  if (typeof fbq !== 'function') {
    return;
  }

  fbq(...args);
};

export default {
  Wetransfer_site_visit() {
    _fbq('track', 'ViewContent', { content_type: 'home' });
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_file_Conversion() {
    _fbq('track', 'AddToWishlist', { content_type: 'free' });
  },
  WeTransfer_Site_Landing_Page_Overlay_WT_plus_send_file_Conversion() {
    _fbq('track', 'AddToWishlist', { content_type: 'plus' });
  },
  WeTransfer_Got_Plus() {
    _fbq('track', 'AddToCart', { content_type: 'homeentry' });
  },
  WeTransfer_Plus_Homepage_Visit() {
    _fbq('track', 'ViewContent', { content_type: 'plus' });
  },
  WeTransfer_Sign_Me_Up_Button_Conversion() {
    _fbq('track', 'AddToCart', { content_type: 'signmeup' });
  },
  WeTransfer_Get_Plus_Conversion() {
    _fbq('track', 'AddToCart', { content_type: 'plustop' });
  },
  WeTransfer_More_About_Plus_Button_Conversion() {
    _fbq('track', 'AddToCart', { content_type: 'plusbottom' });
  },
  WT_Plus_Add_Payment_Conv() {
    _fbq('track', 'AddPaymentInfo');
  },
  Wetransfer_Plus_Complete_Order_Conv() {
    _fbq('track', 'InitiateCheckout');
  },
  WeTransfer_Plus_Confirmation_Page_Conversion() {
    _fbq('track', 'Purchase');
  },
  WeTransfer_Plus_Complete_Payment_Button_return_Conversion() {
    _fbq('track', 'AddToCart', { content_type: 'returncomplete' });
  },
  WT_Plus_go_to_Check_out_Conv() {
    _fbq('track', 'AddToCart', { content_type: 'returngotocheck' });
  },
  WeTransfer_Account_Cancel_Subscription_Click() {
    _fbq('track', 'Schedule');
  },
  WeTransfer_Account_Cancel_Subscription_Go_Ahead_Click() {
    _fbq('track', 'StartTrial');
  },
  WeTransfer_Account_Reactivate_Plus_Conversion() {
    _fbq('track', 'SubmitApplication');
  },
  WeTransfer_Reactivate_Plus_Go_Ahead_Conversion() {
    _fbq('track', 'FindLocation');
  },
};
